import { AutoLinkContext } from '@betterment/js-runtime';
import { SentryErrorBoundary } from '@betterment/shared-components';
import { RouterProvider, RouterProviderProps, createBrowserRouter } from 'react-router-dom';

import { NotFound } from '../RetailApp/components/NotFound';
import { pangeaRoutes } from '../RetailApp/components/PangeaRoutes';
import { Root } from '../RetailApp/components/Root';
import { RetailAppProvider } from '../RetailApp/providers/RetailAppProvider';
import { urlBuilder } from '../Shared/urlBuilder';

type Router = RouterProviderProps['router'];

export type RetailAppProps = {
  router: Router;
};

const autoLinkContextValue = {
  routes: pangeaRoutes,
  basename: urlBuilder.appHome.absolute(),
};

/**
 * Creates a new router instance for the React SPA.
 */
export function createRouter(): Router {
  return createBrowserRouter(
    [
      {
        path: '/',
        element: <Root />,
        children: [...pangeaRoutes, { path: '*', element: <NotFound /> }],
      },
    ],
    { basename: urlBuilder.appHome.absolute() }
  );
}

const RetailApp: React.FC<RetailAppProps> = ({ router }) => (
  <SentryErrorBoundary fallbackType="full">
    <RetailAppProvider>
      <AutoLinkContext.Provider value={autoLinkContextValue}>
        <RouterProvider router={router} />
      </AutoLinkContext.Provider>
    </RetailAppProvider>
  </SentryErrorBoundary>
);

export default RetailApp;
